export const getOrderDetailsPath = (id: string, orderDetailsType: string) =>
  `/orders/${id}?orderDetailsType=${orderDetailsType}`;

export const getFileDownloadPath = (fileName: string) => {
  const encodedFileName = encodeURIComponent(fileName);

  return `file-download/${encodedFileName}`;
};
